import { useEffect, useState } from "react";
import { v4 as uuidv4 } from 'uuid';
import callAPI from "../fetch/main";
import { Flex, message, Radio, Switch, Tag, Alert, Button, Select, Empty, Skeleton, Popover, Modal, Spin } from "antd";
import './main.css';
import { Link } from "react-router-dom";

import { CloseCircleOutlined, PlusCircleOutlined, StepForwardOutlined, FastForwardOutlined, ThunderboltOutlined, MergeOutlined, CommentOutlined, EyeOutlined, HeartFilled, ArrowRightOutlined, RightCircleOutlined, SyncOutlined, SortAscendingOutlined, SortDescendingOutlined, SettingOutlined, FilterOutlined, InstagramOutlined, VideoCameraOutlined } from '@ant-design/icons';
import AccessOrNot from "../../funcs/accessOrNot";
function IGPosts({ fb_page, allowMoreAutomation, setShowPlanModal, nextPostsAutomationLimit, hideGlobalAutomation, showOnlyGlobalAutomation }) {

  const [loading, setLoading] = useState(false);
  const [loadMore, setLoadMore] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState('posts')
  const [data, setData] = useState({});
  const [dataAutomated, setDataAutomated] = useState({});
  const [dataAutomatedFormated, setDataAutomatedFormated] = useState({})
  const [oldData, setOldData] = useState([]);
  const [messageApi, contextHolder] = message.useMessage();
  const [loadingAutomated, setLoadingAutomated] = useState()
  const [showGlobalModal, setShowGlobalModal] = useState(false);
  const [globalAutomations, setGlobalAutomations] = useState([]);
  const [loadingGlobal, setLoadingGlobal] = useState(false);

  // State for global automation view
  const [postsAutomations, setPostsAutomations] = useState([]);
  const [storiesAutomations, setStoriesAutomations] = useState([]);

  const fetchGlobalAutomation = () => {
    let apiURL = `quick-global-automate-posts`;
    const params = [];
    if (selectedCategory === 'stories') {
      params.push('is_story=true');
    }
    if (fb_page) {
      params.push('is_fb=true');
    }
    if (params.length > 0) {
      apiURL += `?${params.join('&')}`;
    }
    callAPI({
      url: apiURL,
      method: "GET",
      loadingState: setLoadingGlobal,
      dataState: (response) => {
        if (response?.data?.triger_words) {
          const grouped = {};
          Object.entries(response.data.triger_words).forEach(([word, id]) => {
            if (!grouped[id]) {
              grouped[id] = [];
            }
            grouped[id].push(word);
          });

          const automations = Object.entries(grouped).map(([id, words]) => ({
            id,
            words
          }));
          setGlobalAutomations(automations);
        } else {
          setGlobalAutomations([]);
        }
      }
    });
  };

  const [showFBPlanAccess, setShowFBPlanAccess] = useState()
  const [showFBPlanLaunchModal, setShowFBLaunchModal] = useState()



  const [sortOrder, setSortOrder] = useState("new"); // "new" or "old"

  const [filterPosts, setFilterPosts] = useState(false)

  const [selectedCatChange, setSelectedCatChange] = useState(0)

  const CACHE_KEY = `igPosts-${selectedCategory}-${sortOrder}`;
  const SCROLL_KEY = `ig-scroll-pos`;

  const [adAccounts, setAdAccounts] = useState([])


  useEffect(() => {

    let tempData = {}
    if (dataAutomated["data"] == undefined) {
      return
    }

    dataAutomated["data"].map((item) => {
      if (item?.flow_editor == true) {
        tempData[item.post_id] = "flow_editor"
      }
      else {
        tempData[item.post_id] = item.automated_segment.length > 0 ? true : false
      }

    })

    setDataAutomatedFormated(tempData)
    // let apiURL = `ig-usage-stat?tz=${user_tz}`
    // callAPI({ url: apiURL, method: "GET", loadingState: setLoadingUserUsage, dataState: setUserUsage })

    // let apiURL2 = `user_plan`
    // callAPI({ url: apiURL2, method: "GET", loadingState: setUserPlanLoading, dataState: setUserPlan })



  }, [dataAutomated])
  // Restore scroll position
  useEffect(() => {
    const y = sessionStorage.getItem(SCROLL_KEY);
    if (y) {
      setTimeout(() => {
        window.scrollTo(0, parseInt(y));
      }, 100);
    }
  }, []);

  useEffect(() => {
    const savedFilter = sessionStorage.getItem("igPosts-filterPosts");

    sessionStorage.getItem("igPosts-filterPosts");
    if (savedFilter) {
      try {
        const parsed = JSON.parse(savedFilter);
        const now = Date.now();
        const maxAge = 5 * 60 * 1000; // 5 minutes

        if (now - parsed.time < maxAge) {
          setFilterPosts(parsed.value);
        } else {
          sessionStorage.removeItem("igPosts-filterPosts");
        }
      } catch {
        sessionStorage.removeItem("igPosts-filterPosts");
      }
    }
    const savedSort = sessionStorage.getItem("igPosts-sortPosts");

    if (savedSort) {
      try {
        const parsed = JSON.parse(savedSort);
        const now = Date.now();
        const maxAge = 5 * 60 * 1000;

        if (now - parsed.time < maxAge) {
          setSortOrder(parsed.value);
        } else {
          sessionStorage.removeItem("igPosts-sortPosts");
        }
      } catch {
        sessionStorage.removeItem("igPosts-sortPosts");
      }
    }
  }, []);


  useEffect(() => {

    if (!filterPosts || filterPosts == "all") {
      return
    }

  }, [filterPosts])

  useEffect(() => {

    // const sessionRaw = sessionStorage.getItem(CACHE_KEY);
    // if (sessionRaw && selectedCatChange == 0) {
    //   console.log("retuing session data")
    //   const parsed = JSON.parse(sessionRaw);
    //   const now = Date.now();
    //   if (now - parsed.time < 5 * 60 * 1000) {
    //     setData(parsed.data);
    //     return;
    //   }
    // }
    setLoading(false)
    setLoadMore(true);

  }, [selectedCategory])
  useEffect(() => {
    console.log("load more change-=-=-=-=-", selectedCatChange)
    if (selectedCatChange == 0) {
      return
    }
    setData()
    setLoadMore(true);
    // setSelectedCatChange(true)

  }, [selectedCatChange])

  useEffect(() => {
    callAPI({
      url: `automate-post`,
      method: "GET",
      loadingState: () => { },
      dataState: setDataAutomated
    });

    // Fetch global automations if in global mode
    if (showOnlyGlobalAutomation) {
      fetchGlobalAutomation();
    }
  }, []);

  // Refetch global automations when category changes in global mode
  useEffect(() => {
    if (showOnlyGlobalAutomation) {
      fetchGlobalAutomation();
    }
  }, [selectedCategory, showOnlyGlobalAutomation]);

  // Fetch automations for both posts and stories when in global mode
  useEffect(() => {
    if (showOnlyGlobalAutomation) {
      // Fetch posts automations
      const postsParams = [];
      if (fb_page) {
        postsParams.push('is_fb=true');
      }
      const postsURL = `quick-global-automate-posts${postsParams.length > 0 ? '?' + postsParams.join('&') : ''}`;

      callAPI({
        url: postsURL,
        method: "GET",
        loadingState: setLoadingGlobal,
        dataState: (response) => {
          if (response?.data?.triger_words) {
            const grouped = {};
            Object.entries(response.data.triger_words).forEach(([word, id]) => {
              if (!grouped[id]) grouped[id] = [];
              grouped[id].push(word);
            });
            const automations = Object.entries(grouped).map(([id, words]) => ({ id, words }));
            setPostsAutomations(automations);
          }
        }
      });

      // Fetch stories automations
      const storiesParams = ['is_story=true'];
      if (fb_page) {
        storiesParams.push('is_fb=true');
      }
      const storiesURL = `quick-global-automate-posts?${storiesParams.join('&')}`;

      callAPI({
        url: storiesURL,
        method: "GET",
        loadingState: () => { },
        dataState: (response) => {
          if (response?.data?.triger_words) {
            const grouped = {};
            Object.entries(response.data.triger_words).forEach(([word, id]) => {
              if (!grouped[id]) grouped[id] = [];
              grouped[id].push(word);
            });
            const automations = Object.entries(grouped).map(([id, words]) => ({ id, words }));
            setStoriesAutomations(automations);
          }
        }
      });
    }
  }, [showOnlyGlobalAutomation]);


  useEffect(() => {
    if (!data?.posts_lists?.data) {
      return
    }
    const sorted = data?.posts_lists?.data?.sort((a, b) => {
      const timeA = new Date(a.timestamp).getTime();
      const timeB = new Date(b.timestamp).getTime();
      return sortOrder === "new" ? timeB - timeA : timeA - timeB;
    });

    setData(
      {
        ...data,
        posts_lists: {
          ...data?.posts_lists,
          data: sorted
        }
      }
    )

  }, [sortOrder])
  // console.log(dataAutomatedFormated , data)
  function addQueryParam(url, key, value) {
    return url + (url.includes("?") ? "&" : "?") + `${key}=${value}`;
  }
  useEffect(() => {
    if (!loadMore || loading) return;

    let apiURL = selectedCategory === "stories" ? "ig-stories" :
      selectedCategory === "collabs" ? "ig-tag-posts" :
        selectedCategory === "next-post" ? "next-post" :
          selectedCategory === "meta-ads" ? "meta-ads" : "ig-posts"


    if (data?.posts_lists?.paging?.cursors?.after) {
      apiURL = addQueryParam(apiURL, "after", data.posts_lists.paging.cursors.after);
    }
    if (selectedCategory == "meta-ads" && localStorage.getItem("ad-account-id")) {
      console.log("Ads selected-=-=-=-=-=-", localStorage.getItem("ad-account-id"))
      apiURL = addQueryParam(apiURL, "adaccounts", localStorage.getItem("ad-account-id"));
    }
    if (fb_page) {
      apiURL = addQueryParam(apiURL, "fb_page", true);

    }

    callAPI({
      url: apiURL,

      method: "GET",

      loadingState: setLoading,

      dataState: (data_) => {


        // if(apiURL == "meta-ads" && data_?.ad_acount_list){
        //   if(!localStorage.getItem("ad-account-id")){
        //     localStorage.setItem("ad-account-id", data_?.ad_acount_list?.data[0]?.id)
        //   }
        //   setAdAccounts(data_?.ad_acount_list?.data)
        // }

        const incoming = data_?.posts_lists?.data || [];
        const existing = data?.posts_lists?.data || [];
        let combined = [...incoming];
        combined = [...existing, ...incoming];



        const sorted = combined.sort((a, b) => {
          const timeA = new Date(a.timestamp).getTime();
          const timeB = new Date(b.timestamp).getTime();
          return sortOrder === "new" ? timeB - timeA : timeA - timeB;
        });
        const mergedData = {
          ...data_,
          posts_lists: {
            ...data_.posts_lists,
            data: sorted
          }
        };

        setData(mergedData);
        console.log("-=-=-=-=-=-", CACHE_KEY, selectedCategory)
        // Save with timestamp
        // sessionStorage.setItem(CACHE_KEY, JSON.stringify({
        //   time: Date.now(),
        //   data: mergedData
        // }));
      }
    });

    setLoadMore(false);
  }, [loadMore]);

  // console.log("data?.posts_lists?.data?.length < nextPostsAutomationLimit" , data?.posts_lists?.data?.length , nextPostsAutomationLimit, data?.posts_lists?.data?.length < nextPostsAutomationLimit)
  const isAutomated = (post_id) => {
    let message = {
      color: "orange",
      content: "Not Automated",
      icon: <CloseCircleOutlined />
    }
    if (dataAutomatedFormated[post_id] == true) {
      message = {
        color: "green",
        content: "Automated",
        icon: <ThunderboltOutlined />
      }
    }
    else if (dataAutomatedFormated[post_id] == "flow_editor") {
      message = {
        color: "green",
        content: "Flow Editor",
        icon: <MergeOutlined />
      }
    }
    else {

    }

    return <Tag icon={message.icon} style={{ fontSize: "12px" }} color={message.color}>{message.content}</Tag>

  }
  const [highlight, setHighlight] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setHighlight(false);
    }, 35000); // Show animation for 5 seconds

    return () => clearTimeout(timer);
  }, []);


  let page_title = {
    "stories": fb_page ? "Facebook Stories" : "Instagram Stories",
    "collabs": "Instagram Collabs",
    "next-post": "Next Post Automation",
    "meta-ads": "Meta Ads(Instagram)",
    "posts": fb_page ? "Facebook Posts (Beta)" : "Instagram Posts"
  }

  // If showOnlyGlobalAutomation is true, show a different view
  if (showOnlyGlobalAutomation) {

    const AutomationCard = ({ title, description, icon, type, automations, isComingSoon }) => (
      <div style={{
        background: 'white',
        border: '2px solid #E8EAED',
        borderRadius: '10px',
        padding: '20px',
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        minHeight: '200px',
        transition: 'all 0.3s ease'
      }}
        onMouseEnter={(e) => {
          e.currentTarget.style.borderColor = '#1890ff';
          e.currentTarget.style.boxShadow = '0 4px 12px rgba(24, 144, 255, 0.15)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.borderColor = '#E8EAED';
          e.currentTarget.style.boxShadow = 'none';
        }}
      >
        <Flex justify="space-between" align="flex-start" style={{ marginBottom: '12px' }}>
          <div style={{ fontSize: '28px' }}>{icon}</div>
          {isComingSoon && (
            <Tag color="orange">Coming Soon</Tag>
          )}
        </Flex>

        <h3 style={{ fontSize: '18px', fontWeight: 600, marginBottom: '8px', color: '#262626' }}>{title}</h3>
        <p style={{ fontSize: '14px', color: '#666', marginBottom: '16px', lineHeight: '1.5', flex: 1 }}>{description}</p>

        {!isComingSoon && (
          <>
            {loadingGlobal ? (
              <div style={{ textAlign: 'center', padding: '20px' }}>
                <Spin />
              </div>
            ) : automations.length > 0 ? (
              <div style={{ marginBottom: '16px' }}>
                <Flex justify="space-between" align="center" style={{ marginBottom: '12px' }}>
                  <span style={{ fontSize: '13px', color: '#666', fontWeight: 500 }}>
                    {automations.length} Active Automation{automations.length > 1 ? 's' : ''}
                  </span>
                  <Button
                    type="link"
                    size="small"
                    onClick={() => {
                      const uniqueId = uuidv4();
                      window.location.href = `/manage-post/${uniqueId}?post_type=${type}&platform_type=${fb_page ? "fb" : "insta"}&is_global=true`;
                    }}
                  >
                    + Add New
                  </Button>
                </Flex>

                <div style={{ maxHeight: '150px', overflowY: 'auto' }}>
                  {automations.map((group, index) => (
                    <div key={index} style={{
                      background: '#fafafa',
                      padding: '10px 12px',
                      borderRadius: '8px',
                      marginBottom: '8px',
                      border: '1px solid #f0f0f0'
                    }}>
                      <Flex justify="space-between" align="center" gap={8} wrap="wrap">
                        <Flex gap={4} wrap="wrap" style={{ flex: 1, minWidth: 0 }}>
                          {group.words.slice(0, 3).map((word, wIndex) => (
                            <Tag key={wIndex} color="blue" style={{ margin: 0 }}>
                              {word === '*allwordautomation*' ? 'Any Comment / Reply' : word}
                            </Tag>
                          ))}
                          {group.words.length > 3 && (
                            <Tag color="default" style={{ margin: 0 }}>+{group.words.length - 3}</Tag>
                          )}
                        </Flex>
                        <Button
                          type="primary"
                          size="small"
                          onClick={() => {
                            window.location.href = `/manage-post/${group.id}?post_type=${type}&platform_type=${fb_page ? "fb" : "insta"}&is_global=true`;
                          }}
                        >
                          Edit
                        </Button>
                      </Flex>
                    </div>
                  ))}
                </div>
              </div>
            ) : (
              <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description={<span style={{ fontSize: '13px', color: '#999' }}>No automations yet</span>}
                style={{ margin: '16px 0' }}
              />
            )}

            {automations.length === 0 && (
              <Button
                type="primary"
                size="large"
                block
                icon={<PlusCircleOutlined />}
                onClick={() => {
                  const uniqueId = uuidv4();
                  window.location.href = `/manage-post/${uniqueId}?post_type=${type}&platform_type=${fb_page ? "fb" : "insta"}&is_global=true`;
                }}
              >
                Create First Automation
              </Button>
            )}
          </>
        )}

        {isComingSoon && (
          <Button
            size="large"
            block
            disabled
            style={{ marginTop: 'auto' }}
          >
            Coming Soon
          </Button>
        )}
      </div>
    );

    return (
      <div className="ig-posts white-bg-border" style={{ height: "100vh", overflowY: "scroll", paddingBottom: "100px" }}>
        {contextHolder}

        <div style={{ marginBottom: '24px' }}>
          <h3 style={{ fontSize: '20px', fontWeight: 600, marginBottom: '8px', margin: 0 }}>Quick Global Automation</h3>
          <p style={{ fontSize: '14px', color: '#666', lineHeight: '1.5', margin: 0, marginTop: '8px' }}>
            Set up automations that work across all your content. When someone comments or replies with your trigger words,
            they'll automatically receive your configured response via DM.
          </p>
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
          gap: '16px',
          marginBottom: '24px'
        }}>
          <AutomationCard
            title="Posts Automation"
            description="Automate responses to comments on all your Instagram posts. Perfect for sharing links, resources, or engaging with your audience at scale."
            icon="📸"
            type="posts"
            automations={postsAutomations}
          />

          <AutomationCard
            title="Stories Automation"
            description="Automate replies to story mentions and responses. Engage with your audience instantly when they interact with your stories."
            icon="📱"
            type="stories"
            automations={storiesAutomations}
          />


        </div>

        <Alert
          message="How Global Automation Works"
          description={
            <div>
              <p style={{ marginBottom: '8px', fontSize: '14px' }}>Global automations apply to all your content automatically:</p>
              <ul style={{ marginLeft: '20px', marginBottom: 0, fontSize: '14px' }}>
                <li><strong>Posts:</strong> Triggers when someone comments with your keywords on any post</li>
                <li><strong>Stories:</strong> Triggers when someone replies to any story with your keywords</li>
                <li><strong>DMs:</strong> Will trigger when someone sends a DM with your keywords (coming soon)</li>
              </ul>
            </div>
          }
          type="info"
          showIcon
        />
      </div>
    );
  }

  return (
    <div className="ig-posts white-bg-border" style={{ height: "100vh", overflowY: "scroll", paddingBottom: "100px" }}>
      {contextHolder}
      <Flex className="ig-posts-filter" gap="middle" justify="space-between" align="center" wrap >
        <Flex gap="middle" justify="space-between" align="center">
          <h3 style={{ textAlign: "center", width: "fit-content" }}> {page_title[selectedCategory]} </h3>
          {!hideGlobalAutomation && (selectedCategory === 'posts' || selectedCategory === 'stories') && (
            <Tag color="blue" style={{ cursor: "pointer" }} onClick={() => {
              setShowGlobalModal(true);
              fetchGlobalAutomation();
            }}>
              All Post Automation
            </Tag>
          )}
        </Flex>

        {!fb_page && <Flex className="desktop" align="center" justify="flex-end" gap={10} wrap style={{ width: "fit-content", flex: "1" }}>
          <Select
            defaultValue={sortOrder}
            className="ig-posts-sort-option desktop"

            onChange={(value) => {
              setSortOrder(value);
              setData({});
              setLoadMore(true);
              // alert(selectedCategory)
              // console.log("-=-=-=-=-storage" , selectedCategory)
              sessionStorage.removeItem(`igPosts-${selectedCategory}-${value}`);
            }}
            options={[
              { label: <Flex><SortAscendingOutlined /> <p style={{ marginLeft: "10px" }}>New to Old Posts</p></Flex>, value: "new" },
              { label: <Flex><SortDescendingOutlined /><p style={{ marginLeft: "10px" }}>Old to New Posts</p></Flex>, value: "old" }
            ]}
          />
          <Radio.Group defaultValue="posts" size="medium" buttonStyle="solid" onChange={
            (e) => {
              setSelectedCategory(e.target.value);
              setSelectedCatChange(selectedCatChange + 1);

              console.log("-=-=-=-=-storage", e.target.value, `igPosts-${e.target.value}-${sortOrder}`)
              sessionStorage.removeItem(`igPosts-${e.target.value}-${sortOrder}`);
            }}>
            <Radio.Button value="posts">Posts</Radio.Button>
            {/* <Radio.Button value="collabs">Collabs</Radio.Button> */}
            <Radio.Button value="stories">Stories</Radio.Button>
            <Radio.Button value="meta-ads">Meta Ads</Radio.Button>
            <Radio.Button value="next-post">Next Post Automation</Radio.Button>
          </Radio.Group>
          <Flex gap={10} className="white-bg-border" justify="space-between" style={{ padding: "4px", width: "fit-content" }}>
            <p style={{ margin: 0 }}>Only Automated</p>
            <Switch defaultChecked={filterPosts} value={filterPosts} onChange={(value) => {
              setFilterPosts(value);
              sessionStorage.setItem("igPosts-filterPosts", JSON.stringify({
                value,
                time: Date.now()
              }));
            }}
            />
          </Flex>

          {/* <Select
          className="mobile"
          defaultValue="posts"
          size="middle"
          style={{ width: "90%" }}
          onChange={value => {
            setSelectedCategory(value);
            setSelectedCatChange(selectedCatChange + 1);
            console.log("-=-=-=-=-storage", value, `igPosts-${value}-${sortOrder}`);
            sessionStorage.removeItem(`igPosts-${value}-${sortOrder}`);
          }}
          options={[
            { value: "posts", label: "Posts" },
            { value: "stories", label: "Stories" },
            { value: "next-post", label: "Next Post Automation" }
          ]}
        />
         <Flex gap={10} className="white-bg-border" justify="space-between" style={{padding:"4px", width:"fit-content"}}>
          <p style={{margin:0}}>Only Automated</p>
          <Switch defaultChecked={filterPosts} value={filterPosts} onChange={(value) => {
              setFilterPosts(value);
              sessionStorage.setItem("igPosts-filterPosts", JSON.stringify({
                value,
                time: Date.now()
              }));
            }}
          />
        </Flex>
        
          <Select
      
          defaultValue={sortOrder}
          value={sortOrder}
          className="ig-posts-sort-option mobile"
          
          onChange={(value) => {
          const sortPayload = {
            value,
            time: Date.now()
          };
          sessionStorage.setItem("igPosts-sortPosts", JSON.stringify(sortPayload));
          setSortOrder(value);
          sessionStorage.removeItem(`igPosts-${selectedCategory}-${value}`);
        }}

          options={[
            { label: <Flex><SortAscendingOutlined/> <p  style={{marginLeft:"10px"}}>New to Old Posts</p></Flex>, value: "new" },
            { label: <Flex><SortDescendingOutlined/><p  style={{marginLeft:"10px"}}>Old to New Posts</p></Flex>, value: "old" }
          ]}
        /> */}




        </Flex>}

        <Flex justify="end" style={{ marginRight: "20px" }}>
          <Popover
            placement="bottomLeft"
            trigger="click"
            className="mobile"
            content={
              <div style={{ minWidth: "200px" }}>
                <div style={{ marginBottom: 12 }}>
                  <b>Category</b>
                  <Select
                    value={selectedCategory}
                    style={{ width: "100%", marginTop: 4 }}
                    onChange={(value) => {
                      setSelectedCategory(value);
                      setSelectedCatChange(selectedCatChange + 1);
                      sessionStorage.removeItem(`igPosts-${value}-${sortOrder}`);
                    }}
                    options={[
                      { value: "posts", label: "Posts" },
                      // { value: "collabs", label: "Collabs" },
                      { value: "stories", label: "Stories" },
                      { value: "meta-ads", label: "Meta Ads" },
                      { value: "next-post", label: "Next Post Automation" }
                    ]}
                  />
                </div>

                <div style={{ marginBottom: 12 }}>
                  <b>Sort By</b>
                  <Select
                    value={sortOrder}
                    style={{ width: "100%", marginTop: 4 }}
                    onChange={(value) => {
                      const sortPayload = { value, time: Date.now() };
                      sessionStorage.setItem("igPosts-sortPosts", JSON.stringify(sortPayload));
                      setSortOrder(value);
                      sessionStorage.removeItem(`igPosts-${selectedCategory}-${value}`);
                    }}
                    options={[
                      { label: "New to Old", value: "new" },
                      { label: "Old to New", value: "old" }
                    ]}
                  />
                </div>


                <div>
                  <Flex justify="space-between" align="center">
                    <span><b>Only Automated</b></span>
                    <Switch
                      checked={filterPosts === true}
                      onChange={(value) => {
                        setFilterPosts(value);
                        sessionStorage.setItem("igPosts-filterPosts", JSON.stringify({
                          value,
                          time: Date.now()
                        }));
                      }}
                    />
                  </Flex>
                </div>

              </div>
            }
          >

            <Button onClick={() => { setHighlight(false) }} className={highlight ? "filter-animate" : ""} icon={<FilterOutlined />} />

          </Popover>
        </Flex>
      </Flex>

      <div style={{ marginTop: "20px" }} />

      {data?.posts_lists?.data?.length === undefined &&
        <Flex justify="center" align="center" gap={16} wrap>
          {Array(9).fill(0).map((_, idx) => (
            <Skeleton.Image
              key={idx}
              style={{
                width: '140px',
                height: "180px",
                margin: '10px 0',
                borderRadius: '12px'
              }}
              loading={true}
              active
            />
          ))}
        </Flex>
      }

      {
        selectedCategory != "meta-ads" && data?.posts_lists?.data?.length == 0 &&
        <Empty description="No content." >
          <Flex gap={"20px"} wrap justify="center" align="center">
            <Button loading={loading} color="primary" variant="dashed" style={{ marginTop: "20px" }} icon={<SyncOutlined />} onClick={() => {
              setSelectedCatChange(selectedCatChange + 1)
            }}>
              Re-Load Posts
            </Button>
            <Button loading={loading} color="danger" variant="solid" style={{ marginTop: "20px" }} icon={<InstagramOutlined />} href={fb_page ? "/ig-connect" : "/ig-connect?show_ig_connect=true"} >
              {fb_page ? "Reconnect FB Page" : "Reconnect Instagram"}
            </Button>
          </Flex>
        </Empty>
      }

      {
        selectedCategory == "meta-ads" && data?.posts_lists?.data?.length == 0 &&
        <Empty description="No Ads found." >
          <Flex gap={"20px"} wrap justify="center" align="center">
            <Button loading={loading} color="primary" variant="dashed" style={{ marginTop: "20px" }} icon={<SyncOutlined />} onClick={() => {
              setSelectedCatChange(selectedCatChange + 1)
            }}>
              Re-Load Ads
            </Button>
            <Button loading={loading} color="danger" variant="solid" style={{ marginTop: "20px" }} icon={<InstagramOutlined />} href="/ig-connect" >
              Reconnect Facebook Page
            </Button>
          </Flex>
        </Empty>
      }
      {
        loadMore != true && sortOrder == "old" && (data?.posts_lists?.paging?.cursors?.after != undefined) &&
        <Button loading={loading} color="primary" variant="solid" style={{ marginTop: "20px", marginBottom: "20px" }} icon={<SyncOutlined />} onClick={() => { setLoadMore(true) }}>
          Load more
        </Button>
      }

      {
        (data?.posts_lists?.data != undefined && (selectedCategory == "stories" || selectedCategory == "posts" || selectedCategory == "collabs")) &&

        <Flex justify="flex-start" gap={10} align="center" wrap >
          {data?.posts_lists?.data.map((post, index) => {
            if (filterPosts == true && dataAutomatedFormated[post.id] != true) {
              return null
            }
            return (
              <Link className=" ig-post-card" key={post.id} state={{ post: post }}


                // to={`/manage-post/${post.id}?post_type=${selectedCategory}&flow_editor=${dataAutomatedFormated[post.id] == "flow_editor"}`}
                to={
                  (!AccessOrNot("fb_automation") && fb_page) ? undefined : (dataAutomatedFormated[post.id] != true &&
                    dataAutomatedFormated[post.id] != "flow_editor" &&
                    allowMoreAutomation === false)
                    ? undefined
                    : `/manage-post/${post.id || post.post_id}?post_type=${selectedCategory}&flow_editor=${dataAutomatedFormated[post.id || post.post_id] == "flow_editor"}&platform_type=${fb_page ? "fb" : "insta"}`
                }
                onClick={e => {
                  if (!AccessOrNot("fb_automation") && fb_page) {
                    e.preventDefault();
                    setShowFBPlanAccess(true)
                    return
                  }
                  // if(fb_page){
                  // e.preventDefault();
                  // setShowFBLaunchModal(true)
                  // return
                  // }
                  if (
                    dataAutomatedFormated[post.id] != true &&
                    dataAutomatedFormated[post.id] != "flow_editor" &&
                    allowMoreAutomation === false
                  ) {
                    e.preventDefault();
                    setShowPlanModal(true)

                  }

                }}


              >
                <Flex gap="middle" justify="flex-start" align="center" wrap >
                  <img alt={post.caption} style={{ minWidth: '140px', maxWidth: '100%' }} className="thumbnil-img"

                    src={post.thumbnail_url || post.media_url || post.full_picture}
                    onError={(e) => {
                      // e.target.onerror = null; // prevent infinite loop if fallback also fails
                      // e.target.src = post.thumbnail_url || post.media_url
                    }}
                    crossorigin="anonymous" />

                  <div style={{ position: "absolute", top: "10px", right: "4px", fontSize: "16px" }}>
                    {

                      isAutomated(post.id)

                    }
                  </div>
                  {
                    post.username && selectedCategory == "collabs" &&
                    <div style={{
                      position: "absolute",
                      bottom: "10px",
                      right: "4px",
                      fontSize: "12px",
                      background: "white",
                      padding: "2px 5px",
                      borderRadius: "5px",
                      maxWidth: "90%",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap"
                    }}>
                      @{post.username}
                    </div>
                  }
                  {/* <Flex direction="column" gap="middle" justify="space-between" align="center" wrap>
                                    <div>
                                        <CommentOutlined />
                                        {post?.comments_count}
                                    </div>    
                                    <div>
                                        <HeartFilled style={{color:"red"}} />
                                        {post?.like_count}
                                    </div>    
                                    </Flex> */}

                </Flex>
              </Link>
            )
          })}
        </Flex>
      }
      {
        selectedCategory == "next-post" &&

        <div style={{ marginBottom: '30px' }}>
          <Flex wrap align="center" justify="flex-start" gap={"20px"}>
            <h4>Next post automation</h4>
            {/* <Button icon={<VideoCameraOutlined/>}>Watch Video</Button> */}
          </Flex>
          <p style={{ opacity: '.6' }}>Automate your next post before uploading to Instagram! Save time, effort, and never lose engagement.</p>
        </div>
      }

      {
        selectedCategory == "meta-ads" &&

        <div>
          <Flex gap={10} style={{ marginBottom: "10px" }} wrap>

            {data?.ad_acount_list?.data.map((adaccount, index) => (
              <div
                key={index}
                onClick={() => {
                  localStorage.setItem("ad-account-id", adaccount?.id)
                  setData({})
                  setLoadMore(true)
                }}
                style={{
                  padding: "12px 16px",
                  border: "1px solid #e0e0e0",
                  borderRadius: "8px",
                  backgroundColor: localStorage.getItem("ad-account-id") == adaccount?.id ? "#1677ff" : "#fafafa",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
                  cursor: "pointer"
                }}
              >
                <div>
                  <div style={{ fontWeight: "600", fontSize: "16px", color: localStorage.getItem("ad-account-id") == adaccount?.id ? "white" : "#333" }}>
                    {adaccount?.name}
                  </div>
                  <div style={{ fontSize: "14px", color: localStorage.getItem("ad-account-id") == adaccount?.id ? "white" : "#666" }}>
                    {adaccount?.business?.name || "No Business Linked"}
                  </div>
                </div>
              </div>
            ))}

          </Flex>
          <Flex justify="flex-start" gap={10} align="center" wrap >
            {data?.posts_lists?.data.map((post, index) => {
              let ad_og_post_id = post?.creative?.source_instagram_media_id ? post?.creative?.source_instagram_media_id : post?.creative?.effective_instagram_media_id

              if (!ad_og_post_id) {
                return null
              }

              post?.insights?.data?.length > 0 && console.log(post?.insights?.data[0].clicks)
              if (filterPosts == true && dataAutomatedFormated[ad_og_post_id] != true) {
                return null
              }

              return (
                <Link className=" ig-post-card" key={ad_og_post_id}


                  // to={`/manage-post/${post.id}?post_type=${selectedCategory}&flow_editor=${dataAutomatedFormated[post.id] == "flow_editor"}`}
                  to={
                    (dataAutomatedFormated[ad_og_post_id] != true &&
                      dataAutomatedFormated[ad_og_post_id] != "flow_editor" &&
                      allowMoreAutomation === false)
                      ? undefined
                      : `/manage-post/${ad_og_post_id}?post_type=${selectedCategory}&flow_editor=${dataAutomatedFormated[ad_og_post_id] == "flow_editor"}&platform_type=${fb_page ? "fb" : "insta"}`
                  }
                  onClick={e => {
                    if (
                      dataAutomatedFormated[ad_og_post_id] != true &&
                      dataAutomatedFormated[ad_og_post_id] != "flow_editor" &&
                      allowMoreAutomation === false
                    ) {
                      e.preventDefault();
                      setShowPlanModal(true)

                    }
                  }}

                >
                  <Flex gap="middle" justify="flex-start" align="center" style={{ columnGap: "16px", rowGap: "12px", border: "1px solid rgba(189, 186, 186, 0.3)" }} >

                    <img alt={post.caption} style={{ minWidth: '140px', maxWidth: '100%' }} className="thumbnil-img"

                      src={post?.creative?.image_url ? `https://imagecorsworkers.sanjayhotaction.workers.dev/${post?.creative?.image_url}` : post?.creative?.thumbnail_url ? `https://imagecorsworkers.sanjayhotaction.workers.dev/${post?.creative?.thumbnail_url}` : null}
                      onError={(e) => {
                        // e.target.onerror = null; // prevent infinite loop if fallback also fails
                        // e.target.src = post?.creative?.image_url ? post?.creative?.image_url : post?.creative?.thumbnail_url
                      }}
                      crossorigin="anonymous" />

                    <Flex style={{ padding: "10px", flex: 1, width: "60%", maxWidth: "300px" }} vertical >
                      <div style={{ fontSize: "16px" }}>
                        {

                          isAutomated(ad_og_post_id)

                        }
                      </div>
                      <p style={{ margin: 0, fontSize: 14, fontWeight: 500 }}>
                        Ad: {post?.name}
                      </p>
                      <p style={{ margin: 0, fontSize: 13, color: "#666" }}>
                        Ad Set: {post?.adset?.name}
                      </p>
                      <p style={{ margin: 0, fontSize: 12, color: "#999" }}>
                        Campaign: {post?.campaign?.name}
                      </p>

                      {post?.insights?.data?.length > 0 && (

                        <>

                          <p style={{ margin: 0, fontSize: 12, color: "#999" }}>
                            Clicks: {post.insights.data[0].clicks ?? "–"}
                          </p>
                          <p style={{ margin: 0, fontSize: 12, color: "#999" }}>
                            Impressions: {post.insights.data[0].impressions ?? "–"}
                          </p>
                          <p style={{ margin: 0, fontSize: 12, color: "#999" }}>
                            Spend: $
                            {post.insights.data[0].spend
                              ? Number(post.insights.data[0].spend).toFixed(2)
                              : "0.00"}
                          </p>
                        </>
                      )}


                      <Button
                        style={{ marginTop: "10px" }}

                        onClick={(e) => {
                          e.stopPropagation(); // stop parent link
                          window.open(post?.creative?.instagram_permalink_url, "_blank");
                        }}
                        href={post?.creative?.instagram_permalink_url} target="_blank">View Ad</Button>

                      <Button
                        color="primary"
                        variant="solid"
                        style={{ marginTop: "10px" }}>Edit Automation</Button>

                    </Flex>






                  </Flex>
                </Link>
              )
            })}
          </Flex>
        </div>


      }

      {
        (!AccessOrNot("next_post_automation") && selectedCategory == "next-post") && <Alert
          message="Next post automation is not available in your plan"
          description="Next post automation is available in our paid plans. Please upgrade your plan to use this feature."
          type="error"
          style={{ marginBottom: '10px', marginTop: '10px' }}
          action={
            <Button size="large" type="primary" onClick={() => { setShowPlanModal(true) }}>
              Upgrade Plan
            </Button>
          } />
      }
      {
        (AccessOrNot("next_post_automation") && data?.posts_lists?.data?.length > nextPostsAutomationLimit && selectedCategory == "next-post") && <Alert
          message="Next post automation limit reached"
          description={`You have reached the limit of ${nextPostsAutomationLimit} next post automations. Update your plan to increase the limit.`}
          type="error"
          style={{ marginBottom: '10px', marginTop: '10px' }}
          action={
            <Button size="large" type="primary" onClick={() => { setShowPlanModal(true) }}>
              Upgrade Plan
            </Button>
          }
          showIcon />

      }

      {
        selectedCategory == "next-post" &&
        <div className="posts-list" style={{ marginBottom: '60px' }}>

          {
            (AccessOrNot("next_post_automation") && nextPostsAutomationLimit != "Unlimited" && data?.posts_lists?.data?.length < nextPostsAutomationLimit) &&
            <Link style={{ textDecoration: 'none' }} key={data["posts_lists"].data.length > 0 ? Number(data["posts_lists"].data.at(-1).temp_post_id || "0") + 1 : 1} to={`/manage-post/${data["posts_lists"].data.length > 0 ? Number(data["posts_lists"].data.at(-1).temp_post_id || "0") + 1 : 1}?post_type=${selectedCategory}&platform_type=${fb_page ? "fb" : "insta"}`}>
              <div className="next-post-add">
                <PlusCircleOutlined className="arrow-icon" />
                <p>Create next post automation</p>
              </div>
            </Link>
          }

          {data?.posts_lists.data.map((post, index) =>
            post.temp_post_id != undefined &&
            <Link style={{ textDecoration: 'none' }} key={post.temp_post_id} to={`/manage-post/${post.temp_post_id}?post_type=${selectedCategory}&platform_type=${fb_page ? "fb" : "insta"}`}>
              <div className="next-post-add">
                {index == 0 ? <StepForwardOutlined className="arrow-icon" /> : <FastForwardOutlined className="arrow-icon" />}
                <p>{`Next post #${index + 1}`}</p>
              </div>
            </Link>

          )}

        </div>
      }
      {
        loadMore != true && sortOrder == "new" && (data?.posts_lists?.paging?.cursors?.after != undefined) &&
        <Button loading={loading} color="primary" variant="solid" style={{ marginTop: "20px", marginRight: "20px" }} icon={<SyncOutlined />} onClick={() => { setLoadMore(true) }}>
          Load Older Posts
        </Button>
      }
      {selectedCategory != "next-post" && data?.posts_lists?.paging?.cursors?.after != undefined && <Button loading={loading} color="primary" variant="dashed" style={{ marginTop: "20px" }} icon={<SyncOutlined />} onClick={() => {
        setSelectedCatChange(selectedCatChange + 1)


      }}>
        Load Newer Posts
      </Button>

      }

      <Modal
        open={showFBPlanAccess}
        onCancel={() => { setShowFBPlanAccess(false) }}
        footer={null}
        centered
        bodyStyle={{
          borderRadius: "16px",
          padding: "32px 24px",
          background: "linear-gradient(180deg, #ffffff 0%, #f9f9ff 100%)",
          boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
        }}
      >
        <div style={{ textAlign: "center" }}>
          <div
            style={{
              backgroundColor: "#f2e9ff",
              width: 70,
              height: 70,
              borderRadius: "50%",
              margin: "0 auto 16px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img
              src="https://cdn-icons-png.flaticon.com/512/733/733547.png"
              alt="Facebook Icon"
              style={{ width: 36, height: 36 }}
            />
          </div>

          <h2 style={{ fontSize: 22, fontWeight: 600, marginBottom: 10 }}>
            🚀 Facebook Automation is Live!
          </h2>

          <p style={{ fontSize: 15, color: "#555", marginBottom: 12 }}>
            Available on <b>Legend Pro</b> and above plans.
          </p>

          <p style={{ fontSize: 15, color: "#666", marginBottom: 24 }}>
            Upgrade to <b>Legend Pro</b> starting at just
            <span style={{ color: "#e60023", fontWeight: 600 }}> $12/month</span>
            and never lose another Facebook lead again!
          </p>

          <Button
            type="primary"
            size="large"
            style={{
              // background: "linear-gradient(90deg, #6a11cb 0%, #2575fc 100%)",
              border: "none",
              borderRadius: 6,
              fontWeight: 600,
              padding: "10px 28px",
              boxShadow: "0 4px 14px rgba(37,117,252,0.3)"
            }}
            onClick={() => setShowPlanModal(true)}
          >
            Upgrade to Legend Pro
          </Button>

          <div style={{ marginTop: 16 }}>
            <Button
              type="link"
              onClick={() => setShowFBPlanAccess(false)}
              style={{ color: "#777" }}
            >
              Maybe later
            </Button>
          </div>
        </div>
      </Modal>

      <Modal
        open={showFBPlanLaunchModal}
        onCancel={() => setShowFBLaunchModal(false)}
        footer={null}
        centered
        bodyStyle={{
          borderRadius: "18px",
          padding: "36px 28px",
          background: "linear-gradient(180deg, #ffffff 0%, #f8f7ff 100%)",
          boxShadow: "0 8px 28px rgba(0,0,0,0.1)",
        }}
      >
        <div style={{ textAlign: "center" }}>
          {/* Top Badge */}
          <div
            style={{
              display: "inline-block",
              padding: "6px 14px",
              borderRadius: "20px",
              background: "rgba(106, 17, 203, 0.1)",
              color: "#6a11cb",
              fontWeight: 600,
              fontSize: 13,
              marginBottom: 18,
            }}
          >
            🚀 Launching This Weekend
          </div>

          {/* Icon Section */}
          <div
            style={{
              backgroundColor: "#eef0ff",
              width: 80,
              height: 80,
              borderRadius: "50%",
              margin: "0 auto 16px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img
              src="https://cdn-icons-png.flaticon.com/512/733/733547.png"
              alt="Facebook"
              style={{ width: 40, height: 40 }}
            />
          </div>

          {/* Headline */}
          <h2 style={{ fontSize: 24, fontWeight: 700, marginBottom: 10 }}>
            Facebook Automation is Coming 🎯
          </h2>

          {/* Description */}
          <p style={{ fontSize: 15, color: "#555", marginBottom: 10 }}>
            We’re excited to announce that <b>Facebook Automation</b> will be launching
            this <b>Saturday</b>! 🎉
          </p>
          <p style={{ fontSize: 15, color: "#666", marginBottom: 20 }}>
            Connect your Facebook account with updated permissions to enjoy a
            <b> seamless experience </b> and start automating your leads like never before.
          </p>

          {/* Button */}
          <Button
            type="primary"
            size="large"
            style={{
              // background: "linear-gradient(90deg, #6a11cb 0%, #2575fc 100%)",
              border: "none",
              borderRadius: 8,
              fontWeight: 600,
              padding: "10px 28px",
              boxShadow: "0 4px 14px rgba(37,117,252,0.3)",
            }}
            href="/ig-connect"
          // onClick={() => handleConnectFacebook()}
          >
            Connect Facebook
          </Button>

          {/* Optional Footer Note */}
          <div style={{ marginTop: 20, color: "#777", fontSize: 13 }}>
            Tip: Update permissions now for early access to the launch 🚀
          </div>
        </div>
      </Modal>



      <Modal
        title={`All ${selectedCategory === 'posts' ? 'Post' : 'Story'} Automation`}
        open={showGlobalModal}
        onCancel={() => setShowGlobalModal(false)}
        footer={[
          <Button key="create" type="primary" onClick={() => {
            const uniqueId = uuidv4();
            window.location.href = `/manage-post/${uniqueId}?post_type=${selectedCategory}&platform_type=${fb_page ? "fb" : "insta"}&is_global=true`;
          }}>
            Create new all post automation
          </Button>
        ]}
      >
        {loadingGlobal ? <div style={{ textAlign: "center", padding: "20px" }}><Spin /></div> : (
          <div>
            <h4>Active Automations:</h4>
            {globalAutomations.length > 0 ? (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                {globalAutomations.map((group, index) => (
                  <div key={index} style={{ padding: '8px', border: '1px solid #f0f0f0', borderRadius: '8px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '4px' }}>
                      <span style={{ fontSize: '12px', color: '#888' }}>These words share the same automation:</span>
                      <Button size="small" onClick={() => {
                        window.location.href = `/manage-post/${group.id}?post_type=${selectedCategory}&platform_type=${fb_page ? "fb" : "insta"}&is_global=true`;
                      }}>
                        Edit
                      </Button>
                    </div>
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
                      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
                        {group.words.map((word, wIndex) => (
                          word === '*allwordautomation*' ? <Tag key={wIndex} color="gold">All Post Automation</Tag> : <Tag key={wIndex}>{word}</Tag>
                        ))}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <p>No global automations configured.</p>
            )}
          </div>
        )}
      </Modal>
    </div>
  );

}

export default IGPosts;